import { render, staticRenderFns } from "./ButtonUploadImages.vue?vue&type=template&id=90d50640&"
import script from "./ButtonUploadImages.vue?vue&type=script&lang=js&"
export * from "./ButtonUploadImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports